// extracted by mini-css-extract-plugin
export default {"user":"user_user__EaIJD","notification":"user_notification__8UgZh"};